import React, {useState} from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import PtText from "../../core/pt-text/pt-text";
import {styleVars} from "../../../app-style-vars";
import {getTranslation} from "../../../helpers/getTranslation";
import PtIcon from "../../core/pt-icon/pt-icon";
import {useNavigation} from "@react-navigation/native";
import {PtProductPriceDetailsProps} from './pt-product-price-details-props';

export default function PtProductPriceDetails(props: PtProductPriceDetailsProps) {

  /** labels */
  const priceDetailsLabel = props.priceDetailsLabel || getTranslation('order.history.price.details.label') || 'Price details';
  const totalLabel = props.totalLabel || getTranslation('order.history.price.details.total.label') || 'TOTAL';
  const eachLabel = props.eachLabel || getTranslation('order.history.price.details.each.label') || 'EACH';

  /** data */
  const productData = props.productData;

  /** settings */
  const useModal = props.useModal || false;
  const navigation = useNavigation();
  const hideHeader = props.hideHeader || false;
  const detailsVisible = props.detailsVisible || false;
  const useConditions = props.useConditions || true;
  const valueConditionsList = props.valueConditionsList || [];
  const [showDetails, setShowDetails] = useState(detailsVisible);

  const toggleDetails = () => {
    if(useModal && !showDetails) {
      const headerOpts = {
        menuArea: 'back',
        headerTitle: priceDetailsLabel,
        headerIcons: [],
        showLogo: false,
      };
      const component = <PtProductPriceDetails productData={productData} detailsVisible={true} hideHeader={true}/>;
      navigation.navigate('Modal', {headerOptions:headerOpts, componentToRender:component});
    } else {
      if (props.detailsVisibleHandler) {
        props.detailsVisibleHandler(!showDetails)
      }
      setShowDetails(!showDetails);
    }
  }

  return (
    <View style={[styles.productPriceDetailsContainer]}>

      {!hideHeader ?
        <View style={[styles.productPriceDetailsHeader]}>
          <TouchableOpacity onPress={() => toggleDetails()}>
            <PtText style={[styles.headerText]}>
              {priceDetailsLabel}
              <PtIcon iconName={'forward-right'} style={[styles.headerText]}/>
            </PtText>
          </TouchableOpacity>
        </View>
        : null
      }

      {showDetails && productData.erpConditions ?
        <View style={[styles.flyoutContainer]}>
          <View style={[styles.totalsContainer]}>
            <View>
              <PtText style={[styles.totalText]}>
                {totalLabel.toUpperCase()}:
              </PtText>
            </View>
            <View>
              {productData.boschERPPricings?.map((price:any, idx:number) => (
                <View style={[styles.pricesRow]} key={`totalprices-${idx}`}>
                  <View>
                    <PtText style={[styles.totalLabelsText]}>
                      {price.name}
                    </PtText>
                  </View>
                  <View>
                    <PtText style={[styles.totalValuesText, styles[price.color]]}>
                      {price.value?.formattedValue ? price.value.formattedValue : ''}
                    </PtText>
                  </View>
                </View>
              ))}
            </View>
          </View>

          <View style={[styles.eachContainer]}>
            <View>
              <PtText style={[styles.eachText]}>
                {eachLabel.toUpperCase()}:
              </PtText>
            </View>
            <View>
              {useConditions ?
                <View>
                  {productData.erpConditions.map((eachprice:any, idx:number) => (
                    <View style={[styles.pricesRow]} key={`eachprices-${idx}`}>
                      <View>
                        <PtText style={[styles.eachLabelsText]}>
                          {eachprice.text}
                        </PtText>
                      </View>
                      <View>
                        <PtText style={[styles.eachValuesText, styles[eachprice.color]]}>
                          {eachprice.conditionCurrency == 'PCT' ?
                            `${eachprice.percentageValue.unsignedFormattedValue} ${eachprice.totalValue.value !== 0 ? eachprice.totalValue.formattedValue : ''}`
                            :
                            valueConditionsList.includes(eachprice.key) ?
                              eachprice.value.formattedValue
                              :
                              eachprice.totalValue.formattedValue
                          }
                        </PtText>
                      </View>
                    </View>
                  ))}
                </View>
                :
                <View>
                  <PtText>
                    <PtText>flexible prices</PtText>
                  </PtText>
                </View>
              }
            </View>
          </View>
        </View>
        : null
      }
    </View>
  )

}

const styles = StyleSheet.create({
  productPriceDetailsContainer: {},
  productPriceDetailsHeader: {},
  headerText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
    color: styleVars.boschDarkBlue
  },
  flyoutContainer: {
    padding: styleVars.rem(.5),
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: styleVars.boschLightGray,
    width: '100%',
    marginBottom: styleVars.rem(2),
  },
  totalsContainer: {
    marginBottom: styleVars.rem(1),
  },
  totalText: {
    fontSize: styleVars.rem(1),
    textDecorationLine: 'underline',
  },
  eachContainer: {},
  eachText: {
    fontSize: styleVars.rem(1),
    textDecorationLine: 'underline',
  },
  pricesRow:{
    flexDirection:'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: styleVars.rem(.5),
  },
  totalLabelsText: {
    fontSize:styleVars.rem(.875),
  },
  eachLabelsText: {
    fontSize: styleVars.rem(.875),
  },
  totalValuesText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
  },
  eachValuesText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
  },
  black: {
    color: '#000'
  },
  red: {
    color: styleVars.boschRed,
  },
  green: {
    color: styleVars.boschLightGreen
  }
})